const DUMMY_SITE_KEY = '1x00000000000000000000AA'

export const CLOUDFLARE_TURNSTILE_SITE_KEY =
  process.env.NEXT_PUBLIC_CLOUDFLARE_TURNSTILE_SITE_KEY || DUMMY_SITE_KEY
export const TURNSTILE_SCRIPT_URL = `${process.env.NEXT_PUBLIC_TURNSTILE_SCRIPT_URL}?onload=onloadTurnstileCallback`
